// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2RHYk","itemImg":"styles_itemImg__117MV"};